/*
  LIORIVE — colour choice on product cards (snippets/liorive-card-colors.liquid, interactive).
  A colour button shows that real variant on the card: its photo (when Shopify has one), its name in
  place of "N coloris", and every link of the card (title, image, "Voir rapidement") then opens that
  variant. Nothing is added to the cart and the card never navigates from here.
*/
document.addEventListener('click', (event) => {
  const button = event.target.closest('.lr-dot-btn');
  if (!button) return;
  event.preventDefault();
  event.stopPropagation();
  const card = button.closest('.card-wrapper');
  if (!card) return;

  card.querySelectorAll('.lr-dot-btn').forEach((b) => b.setAttribute('aria-pressed', String(b === button)));
  const name = card.querySelector('[data-lr-dots-name]');
  if (name) name.textContent = button.dataset.name;

  const url = button.dataset.url;
  if (url && button.dataset.sibling) {
    // A sister product (one product per colour, e.g. CERVINO): every product link of the card opens it,
    // and the heart saves that one.
    card.querySelectorAll('a[href*="/products/"]').forEach((a) => a.setAttribute('href', url));
    card.querySelectorAll('[data-product-url]').forEach((el) => el.setAttribute('data-product-url', url));
    const fav = card.querySelector('[data-lr-fav]');
    if (fav) {
      fav.dataset.handle = button.dataset.sibling;
      if (button.dataset.title) fav.dataset.title = button.dataset.title;
      document.dispatchEvent(new CustomEvent('lr:fav-resync'));
    }
  } else if (url) {
    const path = new URL(url, window.location.origin).pathname;
    card.querySelectorAll('a[href]').forEach((a) => {
      if (new URL(a.href, window.location.origin).pathname === path) a.setAttribute('href', url);
    });
    card.querySelectorAll('[data-product-url]').forEach((el) => el.setAttribute('data-product-url', url));
  }

  const img = card.querySelector('.card__media img');
  if (img && button.dataset.src) {
    img.setAttribute('srcset', button.dataset.srcset || '');
    img.setAttribute('src', button.dataset.src);
    img.classList.toggle('lr-img--framed', button.dataset.framed === 'true');
    if (button.dataset.sibling) {
      // Packshots are shown whole on the card tone, worn photos fill the frame.
      img.classList.toggle('lr-img--whole', button.dataset.whole === 'true');
      img.classList.toggle('lr-img--photo', button.dataset.whole !== 'true');
    }
    card.classList.add('lr-picked');
  }
});
